<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <el-card class="rightContent">
              <h3>
                <span>{{ $t("taskDetail.detail") }}</span>
                <el-button @click="goBack()" style="float: right">
                  {{ $t("button.back") }}
                </el-button>
              </h3>
              <el-divider></el-divider>
              <!--                            任务信息-->
              <el-form :model="taskDetail" ref="taskDetail" label-width="100px">
                <el-form-item :label="$t('taskDetail.name')" prop="name">
                  {{ taskDetail.name }}
                  <el-tag
                    :type="taskDetail.status | taskBadgeFilter"
                    size="medium"
                    effect="dark"
                  >
                    {{ taskDetail.status | taskStateFilter(te) }}
                  </el-tag>
                </el-form-item>
                <el-form-item :label="$t('taskDetail.type')" prop="type">
                  {{ taskDetail.type | taskTypeFilter(te) }}
                </el-form-item>
                <el-form-item :label="$t('taskDetail.time')" prop="timeSE">
                  {{ taskDetail.beginTime }} -- {{ taskDetail.endTime }}
                </el-form-item>
                <el-form-item
                  :label="$t('taskDetail.initiator')"
                  prop="managerName"
                >
                  {{ taskDetail.managerName }}
                </el-form-item>
                <el-form-item
                  :label="`${$t('taskDetail.taskInfo')} ★`"
                  prop="info"
                  v-if="taskDetail.info"
                >
                  <span v-html="formattedInfo"></span>
                </el-form-item>
              </el-form>
              <el-divider></el-divider>

              <!--               <h3>试卷详情</h3> -->
              <el-form
                :model="paperDetail"
                ref="paperDetail"
                label-width="100px"
              >
                <el-form-item :label="$t('taskDetail.paperName')" prop="name">
                  {{ paperDetail.name }}
                </el-form-item>
                <el-form-item
                  :label="$t('taskDetail.creator')"
                  prop="ownerName"
                >
                  {{ paperDetail.ownerName }}
                </el-form-item>
              </el-form>
              <!--              case案例-->
              <el-card v-if="taskDetail.status === 1">
                <!--  caseList 案例列表-->
                <el-table
                  :data="paperDetail.caselist"
                  :row-key="id"
                  style="width: 100%"
                  v-if="paperDetail.caselist"
                >
                  <el-table-column type="expand">
                    <template v-slot="props">
                      <el-form
                        label-position="left"
                        class="demo-table-expand"
                        label-width="100px"
                      >
                        <!--                        开发者题目参赛须知-->
                        <p
                          v-if="
                            props.row.targetType === targetType.DEVELOPER &&
                            props.row.answerWay === answerWayOption.DEVELOPER &&
                            taskDetail.type === 2
                          "
                        >
                          <!--                          去掉a标签原有css-->
                          <span
                            @click="
                              openLink(
                                'https://www.bilibili.com/video/BV1BH4heVEsC/?spm_id_from=333.999.0.0',
                              )
                            "
                            class="copyIcon"
                            style="color: red"
                          >
                            !!!{{ $t("taskDetail.developerNotice") }}
                          </span>
                        </p>
                        <el-form-item
                          :label="$t('taskDetail.difficulty')"
                          prop="difficult"
                        >
                          <el-rate
                            v-model="props.row.difficulty"
                            disabled
                            style="display: inline-block"
                            :colors="colors"
                          >
                          </el-rate>
                        </el-form-item>
                        <el-form-item :label="$t('taskDetail.description')">
                          <span>{{
                            props.row.description || $t("common.null")
                          }}</span>
                        </el-form-item>
                        <!--                        需求文档-->
                        <el-form-item
                          :label="$t('taskDetail.problem')"
                          v-if="props.row.targetType === targetType.WEB"
                        >
                          <span v-if="props.row.properties_list.length > 0">
                            <span
                              v-for="(property, index) in props.row
                                .properties_list"
                              :key="property"
                              style="margin-left: 5px"
                            >
                              <span
                                @click="openLink(property)"
                                class="copyIcon"
                                style="color: #409eff"
                              >
                                {{ $t("taskDetail.file") }}{{ index + 1 }}:
                                {{
                                  property == ""
                                    ? te("common.null")
                                    : te("common.clickForMore")
                                }}</span
                              >
                            </span>
                          </span>
                          <span v-else class="copyIcon">
                            {{ $t("common.null") }}
                          </span>
                        </el-form-item>
                        <!--                        题目(测试目标) 开发者 / 车联网 / web -->
                        <el-form-item
                          :label="$t('taskDetail.targetFile')"
                          v-if="
                            (props.row.targetType === targetType.DEVELOPER &&
                              props.row.answerWay ===
                                answerWayOption.DEVELOPER) ||
                            props.row.targetType === targetType.V2X ||
                            props.row.targetType === targetType.HARMONY
                          "
                        >
                          <span
                            @click="openLink(props.row.targetUrl)"
                            class="copyIcon"
                            style="color: #409eff"
                          >
                            {{ te("common.download") }}
                          </span>
                        </el-form-item>

                        <!-- 开发者类型不显示密钥 -->
                        <!-- web功能测试不显示密钥 ECLIPESE模式显示密钥-->
                        <el-form-item
                          v-if="
                            props.row.showBtns[caseBtn.SECRET] &&
                            !(
                              props.row.targetType === targetType.DEVELOPER &&
                              props.row.answerWay === answerWayOption.DEVELOPER
                            ) &&
                            !(
                              props.row.targetType === targetType.WEB &&
                              props.row.answerWay ===
                                answerWayOption.WEB_FUNCTION_ONLINE
                            )
                          "
                          :label="$t('taskDetail.key')"
                        >
                          <span>{{ props.row.secret }}</span>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="$t('common.clickToCopy')"
                            placement="top"
                          >
                            <i
                              class="el-icon-document-copy copyIcon"
                              style="margin-left: 10px"
                              @click="copySecret(props.row.secret)"
                            ></i>
                          </el-tooltip>
                        </el-form-item>
                        <!--                        annex-->
                        <el-form-item
                          :label="$t('taskDetail.annexFile')"
                          prop="file"
                          v-if="props.row.showBtns[caseBtn.UPLOAD_FILE]"
                        >
                          <el-upload
                            class="upload-demo"
                            action=""
                            ref="annexFileUploader"
                            :on-change="
                              (file, fileList) => {
                                handleFileChange(file, fileList, props.row.id);
                              }
                            "
                            :auto-upload="false"
                            :limit="1"
                            :file-list="annexFileList"
                          >
                            <div
                              @click="openLink(props.row.annexList[0])"
                              class="copyIcon"
                              style="color: #409eff; text-align: left"
                              v-if="props.row.annexList.length > 0"
                            >
                              {{ props.row.annexList[0] | fileNameFilter }}
                            </div>
                            <div>
                              <el-button size="small" type="primary">
                                {{
                                  props.row.annexList.length > 0
                                    ? $t("taskDetail.uploadAgain")
                                    : $t("taskDetail.upload")
                                }}
                              </el-button>
                            </div>
                          </el-upload>
                        </el-form-item>
                        <!--                        提交答案-->
                        <div
                          v-if="
                            props.row.subjectId === SubjectIdMap.DEVELOPER &&
                            props.row.answerWay === answerWayOption.DEVELOPER
                          "
                        >
                          <UploadHelper
                            v-for="item in submitFileConfig.DEV"
                            :key="item.name"
                            :size-limit="item.size"
                            :accept-type="item.acceptType"
                            :type="item.name"
                            :label="item.label"
                            :submit-file="props.row.submitFile[item.name]"
                            @onUpload="
                              (file) => {
                                onUpload(item.name, props.row.id, file);
                              }
                            "
                          >
                          </UploadHelper>
                        </div>
                        <div v-if="props.row.subjectId === SubjectIdMap.V2X">
                          <UploadHelper
                            v-for="item in submitFileConfig.V2X"
                            :key="item.name"
                            :size-limit="item.size"
                            :accept-type="item.acceptType"
                            :type="item.name"
                            :label="item.label"
                            :submit-file="props.row.submitFile[item.name]"
                            @onUpload="
                              (file) => {
                                onUpload(item.name, props.row.id, file);
                              }
                            "
                          >
                          </UploadHelper>
                        </div>
                        <!-- web ECLIPSE模式不显示提交答案, 在线提交模式显示提交-->
                        <div
                          v-if="
                            props.row.subjectId === SubjectIdMap.WEB_FUNCTION &&
                            props.row.answerWay ===
                              answerWayOption.WEB_FUNCTION_ONLINE
                          "
                        >
                          <UploadHelper
                            v-for="item in submitFileConfig.WEB"
                            :key="item.name"
                            :size-limit="item.size"
                            :accept-type="item.acceptType"
                            :type="item.name"
                            :label="item.label"
                            :submit-file="props.row.submitFile[item.name]"
                            @onUpload="
                              (file) => {
                                onUpload(item.name, props.row.id, file);
                              }
                            "
                          >
                          </UploadHelper>
                        </div>
                        <!-- 鸿蒙 -->
                        <div
                          v-if="props.row.subjectId === SubjectIdMap.HARMONY"
                        >
                          <UploadHelper
                            v-for="item in submitFileConfig.HARMONY"
                            :key="item.name"
                            :size-limit="item.size"
                            :accept-type="item.acceptType"
                            :type="item.name"
                            :label="item.label"
                            :submit-file="props.row.submitFile[item.name]"
                            @onUpload="
                              (file) => {
                                onUpload(item.name, props.row.id, file);
                              }
                            "
                          >
                          </UploadHelper>
                        </div>
                        <!-- download -->
                        <el-form-item
                          v-if="props.row.showBtns[caseBtn.DOWNLOAD_FILE]"
                          :label="$t('taskDetail.download')"
                        >
                          <el-button
                            type="primary"
                            size="small"
                            @click="openLink(props.row.annexList[0])"
                          >
                            {{ $t("taskDetail.download") }}
                          </el-button>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$t('table.title')"
                    min-width="40%"
                  >
                    <template v-slot="props">
                      {{ props.row.name }}
                      <span
                        :class="
                          props.row.submitted ||
                          checkSubmitted(props.row.submitFile)
                            ? 'submited'
                            : 'unsubmit'
                        "
                        >{{
                          props.row.submitted ||
                          checkSubmitted(props.row.submitFile)
                            ? $t("table.submitted")
                            : $t("table.unsubmitted")
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="weight"
                    :label="$t('table.ratio')"
                    min-width="30%"
                  >
                    <template v-slot="props">
                      {{ props.row.weight * 100 + "%" }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="rule"
                    :label="$t('table.rules')"
                    min-width="30%"
                  >
                    <template v-slot="props">
                      <p
                        v-for="(rule, index) in props.row.case_rules"
                        :key="index"
                      >
                        {{ rule.name }}:{{ rule.percentage }}%
                      </p>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CaseButton } from "@/assets/staticData/CaseButton";
import {
  TargetType,
  answerWayOption,
  submitFileConfig,
  SubjectIdMap,
} from "@/config/config";
import {
  taskDetailGet,
  paperDetailGet,
  uploadAnnex,
  getUploadUrl,
} from "@/api/task";
import { timeFormat, openLink } from "@/utils/utils";
import {
  taskTypeFilter,
  fileNameFilter,
  taskStateFilter,
  taskBadgeFilter,
} from "@/utils/filter";
import UploadHelper from "@/components/UploadHelper.vue";
import { uploadFile } from "@/api/oss";

export default {
  name: "taskDetail",
  computed: {
    SubjectIdMap() {
      return SubjectIdMap;
    },
    submitFileConfig() {
      return submitFileConfig;
    },
    // 解析文本，将\n替换为br
    formattedInfo() {
      return this.taskDetail.info
        ? this.taskDetail.info.replace(/\n/g, "<br>")
        : "";
    },
  },
  components: { UploadHelper },
  bodyClass: "index-page",
  filters: {
    taskTypeFilter,
    fileNameFilter,
    taskStateFilter,
    taskBadgeFilter,
  },
  props: {},
  data() {
    return {
      examId: 0,
      paperDetail: {},
      taskDetail: {},
      paperSelectedId: "",
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      caseBtn: CaseButton,
      targetType: TargetType,
      answerWayOption,
      annexFileList: [],
      answerFileList: [],
      scores: {},
      caseScoreList: [],
      expandRows: [],
    };
  },
  mounted() {
    this.examId = this.$route.params.id;
    this.initTaskDetail(this.$route.params.id);
  },

  methods: {
    openLink,
    copySecret(item) {
      const that = this;
      const cInput = document.createElement("input");
      cInput.value = item;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本框内容
      document.execCommand("copy");
      this.$message.success(that.$t("common.copySuccess"));
      // 复制成功后再将构造的标签 移除
      document.body.removeChild(cInput);
    },
    async initTaskDetail(tid) {
      await taskDetailGet(tid).then((res) => {
        res.beginTime = timeFormat(res.beginTime);
        res.endTime = timeFormat(res.endTime);
        this.taskDetail = res;
      });
      this.taskDetail?.status === 2 && this.loadScore();
      this.taskDetail?.paperId && this.loadPaperDetail();
    },
    loadPaperDetail() {
      paperDetailGet(
        this.examId,
        this.paperSelectedId || this.taskDetail.paperId,
      ).then((res) => {
        this.paperDetail = res;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    te(arg) {
      const hasKey = this.$te(arg);
      if (hasKey) {
        return this.$t(arg);
      }
      return arg;
    },
    handleFileChange(file, fileList, id) {
      this.handleUploadAnnex(file, id);
    },

    handleUploadAnnex(file, id) {
      const formData = new FormData();
      const that = this;

      const uname = JSON.parse(localStorage.getItem("user")).name;
      const newName = `答题附件_${uname}.${file.raw.name.split(".").pop()}`;
      const copyFile = new File([file.raw], newName);
      formData.append("file", copyFile);

      uploadAnnex(this.examId, id, formData).then((res) => {
        console.log(res);
        this.$notify({
          type: "success",
          title: that.$t("common.success"),
          duration: 3000,
        });
        this.annexFileList.pop();
        this.loadPaperDetail();
      });
    },
    onUpload(type, caseId, file) {
      const that = this;
      const workerId = JSON.parse(localStorage.getItem("user")).id;
      getUploadUrl(caseId, workerId, this.examId, type, file.name)
        .then((res) => {
          if (res.code === 20000) {
            const url = res?.data?.uploadSigUrl;
            uploadFile(url, file.raw).then(() => {
              this.$notify({
                type: "success",
                title: that.$t("common.success"),
                duration: 3000,
              });
              const index = that.paperDetail.caselist.findIndex(
                (item) => item.id === caseId,
              );
              const [baseUrl] = url.split("?");
              that.paperDetail.caselist[index].submitFile[type] = baseUrl;
            });
          } else {
            throw res;
          }
        })
        .catch((error) => {
          this.$notify({
            type: "error",
            title: this.$t("common.error"),
            message:
              error?.data?.message ||
              error?.msg ||
              this.$t("common.uploadErrorMessage"),
            duration: 3000,
          });
        });
    },
    checkSubmitted(submitFile) {
      if (!submitFile) {
        return false;
      }
      const keys = Object.keys(submitFile);
      for (let i = 0; i < keys.length; i++) {
        if (!submitFile[keys[i]]) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}

.paperOperarion {
  text-align: right;
  margin-bottom: 10px;
}
</style>

<style scoped>
.demo-table-expand {
  font-size: 0;
  margin: 10px 0px 10px 60px;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
}

a {
  text-decoration: none;
  color: inherit;
  cursor: auto;
}
</style>

<style>
.copyIcon {
  cursor: pointer;
}

.submited {
  color: greenyellow;
}

.unsubmit {
  color: red;
}
</style>
